
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as SettingsIconComponent } from "./settings-icon.svg";

export const SettingsIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <SettingsIconComponent {...props} />;
};
